var scope_0 = require('/Users/bm/work/mdx-deck-example/stack/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/004d88d12a00f8988e58c3231ee5f899.js').default;export default
        Object.assign({}, scope_0 )
    